import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import * as RouterActions from '../../../actions/RouterActions';
import { Table, Label, Icon } from 'semantic-ui-react'

export function MarketRow(props){

    let style = {};

    if(props.marketTypeHasChanged)
        style['paddingTop'] = '2em';

    return (
        <Fragment>
            {props.marketTypeHasChanged?
                <Table.Row>
                    <Table.Cell colspan={3} style={style}>
                        <a style={{cursor: 'pointer'}} onClick={props.onClickType}>{props.market.canvas.type}</a>
                    </Table.Cell>
                    <Table.Cell style={{style}}>
                        {props.namesOfType[0]}
                        {
                            (props.namesOfType.length > 1)
                            ?
                                <span style={{
                                    fontStyle: 'italic',
                                    paddingLeft: '1em'
                                }}>(+ {props.namesOfType.length - 1} weitere)</span>
                            :null
                        }
                    </Table.Cell>
                    <Table.Cell style={style}>
                        <a onClick={(e) => {
                            props.toggleShowMarkets()
                        }} style={{
                            cursor: 'pointer'
                        }}><Icon name={props.showMarkets?"caret down":"caret right"} /> {props.marketsOfType} {(props.marketsOfType === 1)?'Markt':'Märkte'} {props.showMarkets?'ausblenden':'einblenden'}</a>
                    </Table.Cell>
                </Table.Row>
                :null
            }
            {
                props.showMarkets?
                    <Table.Row>
                        <Table.Cell style={style}></Table.Cell>
                        <Table.Cell style={style}><a style={{cursor: 'pointer'}} onClick={props.onClickMarket}>{props.market.uid}</a></Table.Cell>
                        <Table.Cell style={style}>{props.market.canvas.id}</Table.Cell>
                        <Table.Cell style={style}>{
                            (typeof props.market.name !== 'undefined')
                                ?props.market.name
                                :(typeof props.market.canvas !== 'undefined')
                                    ?props.market.canvas.name
                                    :'Unknown'
                            }</Table.Cell>
                        <Table.Cell style={style}>
                            {
                                (typeof props.market.description !== 'undefined')
                                    ?props.market.description
                                    :(typeof props.market.canvas !== 'undefined')
                                        ?props.market.canvas.description
                                        :null
                            }
                        </Table.Cell>
                    </Table.Row>
                :null
            }
        </Fragment>
    )
}